import { useMemo } from 'react';
import _ from 'lodash';
import { FuseNavItemType } from '@fuse/core/FuseNavigation/types/FuseNavItemType';
import usePathname from '@fuse/hooks/usePathname';
import useNavigation from '@/components/theme-layouts/components/navigation/hooks/useNavigation';

/**
 * Hook to get the current navigation item based on the current pathname
 * Recursively searches through navigation items and their children
 */
function useCurrentNavigation(navigationItems?: FuseNavItemType[]): FuseNavItemType | null {
	const pathname = usePathname();
	const { navigation: defaultNavigation } = useNavigation();
	
	const navigation = navigationItems || defaultNavigation;

	const currentNavItem = useMemo(() => {
		// Recursive function to find navigation item by URL
		const findNavItemByUrl = (items: FuseNavItemType[], url: string): FuseNavItemType | null => {
			for (const item of items) {
				// Check if this item matches
				if (item.url === url || (item.url && url.startsWith(item.url + '/'))) {
					return item;
				}

				// Check children recursively
				if (item.children) {
					const childMatch = findNavItemByUrl(item.children, url);
					if (childMatch) {
						return childMatch;
					}
				}
			}
			return null;
		};

		return findNavItemByUrl(navigation, pathname);
	}, [navigation, pathname]);

	return currentNavItem;
}

export default useCurrentNavigation;

